import {Component, OnInit} from '@angular/core';
import {ContactUsService} from '../contact-us.service';
import {BranchDBService} from '../../@db/branch-db.service';
import {Router} from '@angular/router';
import {ContactUsDBService} from '../../@db/contact-us-db.service';


@Component({
  selector: 'bb-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent implements OnInit {
  branches = this.branchDb.list.filter(b => b.is_lead_choice).toArray();

  constructor(public contactUs: ContactUsService,
              public branchDb: BranchDBService,
              private contactUsDb: ContactUsDBService,
              private router: Router) {
  }

  ngOnInit() {
  }

  public sendMessage() {
    if (this.contactUs.form.valid) {
      this.contactUsDb.sendMessage(this.contactUs.form.value).subscribe(() => this.router.navigate(['/contact-us/thank-you']));
    } else {
      if (this.contactUs.form.get('branch').invalid) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    }
  }
}
